import { BaseApi } from './base.api.js';

export class EvidenceBundleApi extends BaseApi {
    constructor(client) {
        super(client, '/evidence-bundles');
    }

    async list(entityType, entityId) {
        const response = await this.client.get(this.basePath, { params: { entityType, entityId } });
        return response.data;
    }

    async seal(id) {
        const response = await this.client.post(`${this.basePath}/${encodeURIComponent(String(id))}/seal`, {});
        return response.data;
    }

    async export(id, format = 'json') {
        const response = await this.client.post(
            `${this.basePath}/${encodeURIComponent(String(id))}/export`,
            { format },
            { responseType: 'text' },
        );
        return {
            data: response.data,
            metadata: {
                checksum: response.headers?.['x-evidence-checksum'] || '',
                contentType: response.headers?.['content-type'] || '',
            },
        };
    }
}
